import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=1ea8d48e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea8d48e')) {
      api.createRecord('1ea8d48e', component.options)
    } else {
      api.reload('1ea8d48e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=1ea8d48e&", function () {
      api.rerender('1ea8d48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21kKXk9p4rI8L/JS/videoIframe.vue"
export default component.exports